document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.custom-tabs-container');
    containers.forEach(container => {
        const navButtons = container.querySelectorAll('.custom-tabs__nav-button');
        const contentPanes = container.querySelectorAll('.custom-tabs__content');

        navButtons.forEach(button => {
            button.addEventListener('click', () => {
                const targetPaneId = button.dataset.tabTarget;

                // ボタンのアクティブ状態を更新
                navButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                // コンテンツのアクティブ状態を更新
                contentPanes.forEach(pane => {
                if (pane.id === targetPaneId.substring(1)) {
                    pane.classList.add('active');
                } else {
                    pane.classList.remove('active');
                }
                });
            });
        });
    });
});
